(() => {
  "use strict";

  angular.module("uwAgenda.agenda")
    .controller(
      "AgendaOverviewController",
      [
        "$scope",
        "$state",
        "$stateParams",
        "$rootScope",
        "$translate",
        "SharedAgendaService",
        "AgendaOverviewService",
        "AgendaTransitionService",
        "CallsService",
        "AgendaFilterBroadcast",
        "ProtocolBroadcastService",
        "ProtocolFilter",
        "$uibModal",
        "AgendaBroadcast",
        '$uibModalStack',
        'HelperService',
        'GroupPracticeService',
        'UserService',
        'TranscriptionService',
        AgendaOverviewControllerFn,
      ]);

  function AgendaOverviewControllerFn(
    $scope,
    $state,
    $stateParams,
    $rootScope,
    $translate,
    SharedAgendaService,
    AgendaOverviewService,
    AgendaTransitionService,
    CallsService,
    AgendaFilterBroadcast,
    ProtocolBroadcastService,
    ProtocolFilter,
    $uibModal,
    AgendaBroadcast,
    $uibModalStack,
    HelperService,
    GroupPracticeService,
    UserService,
    TranscriptionService
  ) {
    const vm = this;

    activate();

    function activate() {
      // agenda overview
      vm.overview = {};

      vm.hasDayTaskAgendas = SharedAgendaService.getDayTasksAgendas().length > 0;

      if ($rootScope.isRingfoon && $stateParams.agendaOwnerId) {
        const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        if (guidRegex.test($stateParams.agendaOwnerId)) {
          showAgendasForIncomingCall($stateParams.agendaOwnerId, new Date(), $stateParams.phoneNumber, true);
        } else {
          const agendaOwnerId = parseInt($stateParams.agendaOwnerId, 10);
          if (agendaOwnerId) {
            showAgendasForIncomingCall(agendaOwnerId, new Date(), $stateParams.phoneNumber, false);
          } else {
            showCurrentAgenda();
          }
        }
      } else {
        showCurrentAgenda();
      }

      let listener = $scope.$on(
        AgendaFilterBroadcast.ListRefresh,
        function (event, agendaId) {
          $state.go($state.current, $stateParams, {reload: $state.current});
        }
      );

      $scope.$on("$destroy", function () {
        listener();
        listener = null;
      });
    }

    function showCurrentAgenda() {
      // allow shared agenda-switch
      SharedAgendaService.allow();

      // first clear
      AgendaOverviewService.data.agendas = [];
      AgendaOverviewService.data.lesser = false;
      // which agendas should be shown (day task list and agendas)

      AgendaOverviewService.data.agendas = $stateParams.isDayView
        ? SharedAgendaService.getAgendasShownInDayView()
        : SharedAgendaService.getAgendasShownInWeekView();

      // set service
      vm.overview = AgendaOverviewService.data;
    }

    function stopPreviousActionsAndClearData() {
      // abort copy/paste operation
      $rootScope.$broadcast(AgendaBroadcast.AbortCutCopy);
      UserService.clearExternalPatient();
      AgendaOverviewService.clear();
      // clear incoming phone number because if no CLIP is sent from doctor, previous number is still stored
      CallsService.incomingCall.phoneNumber = '';
    }

    function shortenAndSetPhoneNumberOfTheIncomingCall(phoneNumber) {
      // fix for innovaphone incoming number but todo: logic should move to backend as well
      if (phoneNumber.startsWith("00032")) {
        phoneNumber = "0" + phoneNumber.substring(5);
      } else if (phoneNumber.startsWith("000")) {
        phoneNumber = "00" + phoneNumber.substring(3);
      }
      // set incoming phone number
      CallsService.incomingCall.phoneNumber = phoneNumber;

      CallsService.incomingCall.isCallFromDoctor = false;
      CallsService.incomingCall.doctorName = '';
      
      return phoneNumber;
    }

    function shortenNumber(number) {
      if (number.startsWith("04")) {
        number = number.substring(2, number.length);
      } else if (number.startsWith("00324") || number.startsWith("00316")) {
        number = number.substring(5, number.length);
      } else {
        if (number.startsWith("324") || number.startsWith("316")) {
          number = number.substring(3, number.length);
        }
      }

      return number;
    }

    function findAgendaOwnerThatIsCalling(agendaOwners, phoneNumber) {
      return agendaOwners
        .find(agendaOwner => {
          if (agendaOwner.contactInfos && agendaOwner.contactInfos.length > 0) {
            let matchingContactInfo = agendaOwner.contactInfos.filter(contactInfoValue => {
              let number = shortenNumber(contactInfoValue.contactInfo);
              return phoneNumber.includes(number);
            });
            return matchingContactInfo && matchingContactInfo.length > 0;
          }
        });
    }

    function setAgendaOwnerOfIncomingCall(callingAgendaOwner) {
      CallsService.incomingCall.isCallFromDoctor = true;
      CallsService.incomingCall.doctorName = callingAgendaOwner.groupPracticeName ||
        callingAgendaOwner.caption;

      // clear the phoneNumber, since it is not a patient's number
      // and must not be used to look up a patient in the next appointment
      CallsService.incomingCall.phoneNumber = '';
      CallsService.call.talkingTo = '';
    }

    function showAgendasForIncomingCall(agendaOwnerId, date, phoneNumber, isGuid) {
      stopPreviousActionsAndClearData();

      GroupPracticeService
        .getGroupPracticeUsers(agendaOwnerId)
        .then((agendaOwners) => {
          if (!agendaOwners) {
            return;
          }

          if (phoneNumber) {
            phoneNumber = shortenAndSetPhoneNumberOfTheIncomingCall(phoneNumber);
            
            // check if incoming call is from a doctor
            let callingAgendaOwner = findAgendaOwnerThatIsCalling(agendaOwners, phoneNumber);
            if (callingAgendaOwner) {
              setAgendaOwnerOfIncomingCall(callingAgendaOwner);
            } else {
              // set external patient data with phone number so patients can be loaded
              // set external date with phone number only as it is an incoming call. incoming calls are new unknown patients
              UserService.setExternalPatientIncomingData(
                null,
                null,
                '',
                '',
                phoneNumber,
                '',
                null,
                false);
            }
          }

          // don't show dialog if only 1 doctor was found (no selection needs to be made)
          if (agendaOwners.length === 1) {
            changeAgendaOfAgendaOwner(agendaOwners[0], date, phoneNumber);
            return;
          }

          let currentAgendaOwner = isGuid ?
            agendaOwners.find(agendaOwner => agendaOwner.uniqueId === agendaOwnerId) :
            agendaOwners.find(agendaOwner => agendaOwner.id === agendaOwnerId);

          // don't show dialog if current user should not be shown in the selection popup
          if (currentAgendaOwner && !currentAgendaOwner.showOnIncomingCall) {
            changeAgendaOfAgendaOwner(currentAgendaOwner, date, phoneNumber);
            return;
          }

          // don't show dialog if only 1 doctor was found (no selection needs to be made)
          let agendaOwnersToShowOnAnIncomingCall = agendaOwners
            .filter(agendaOwner => agendaOwner.showOnIncomingCall);

          if (agendaOwnersToShowOnAnIncomingCall.length === 1) {
            changeAgendaOfAgendaOwner(agendaOwnersToShowOnAnIncomingCall[0], date, phoneNumber);
            return;
          }

          // list up the group practice users that can be shown 
          CallsService.incomingCall.doctors = agendaOwners;
          showSelectAgendaOwnerModal(date, phoneNumber);
        });
    }

    function showSelectAgendaOwnerModal(date, phoneNumber) {
      // close all possible open modals
      $uibModalStack.dismissAll();

      // also close Quick Sidebar (operator day tasks & agenda search)
      HelperService.closeQuickSidebar();

      const modalInstance = $uibModal.open({
        backdrop: "static",
        keyboard: false,
        windowClass: "quick-sidebar-modal",
        animation: true,
        controller: "NewCallModalController",
        controllerAs: "vm",
        templateUrl: "/app/ringfoon/templates/new-call-modal.template.html",
        size: "xl",
      });

      modalInstance.result.then(function () {
        changeAgendaOfAgendaOwner(
          CallsService.incomingCall.selectedDoctor,
          date,
          phoneNumber
        );
      });
    }

    function changeAgendaOfAgendaOwner(agendaOwner, date, phoneNumber) {

      // select current doctor on popup screen
      CallsService.incomingCall.selectedDoctor = agendaOwner;
      agendaOwner.selected = true;

      AgendaTransitionService
        .change(agendaOwner.id, date)
        .then(() => {
          UserService.getExternalPatientSearchResult(agendaOwner.id)
            .then(patient => {
              CallsService.call.talkingTo = phoneNumber;
              // show 'incoming-call-protocol'
              ProtocolBroadcastService.broadcast(ProtocolFilter.ShowOnInboundCall);
              
              TranscriptionService.openTranscript(agendaOwner.id, phoneNumber);
            });
        });
    }
  }
})();
